// Collection of helpers to manipulate query params.
class ParamsHelper {
  static parseQueryParams(queryParams = '') {
    const params = {};
    const decodedParams = queryParams;
    if (decodedParams.length) {
      decodedParams.slice(1).split('&').forEach((param) => {
        const splitParam = param.split('=').map(URIComponent => window.decodeURIComponent(URIComponent));
        /* eslint-disable-next-line prefer-destructuring */
        params[splitParam[0]] = splitParam[1];
      });
    }
    return params;
  }

  // Receives the current params and a dictionary of params and returns
  // the query param string.
  static updateQueryParams(currentQueryParams = '', newParams) {
    let processedParams = currentQueryParams;
    Object.entries(newParams).forEach(([key, value]) => {
      const encodedKey = window.encodeURIComponent(key);
      const encodedValue = window.encodeURIComponent(value);
      // Search for a page param and replace it if it exists
      if (!processedParams.length) {
        processedParams = `?${encodedKey}=${encodedValue}`;
      } else if (processedParams.search(new RegExp(`[?&]${encodedKey}=`)) > -1) {
        processedParams = processedParams.replace(
          new RegExp(`([?&])${encodedKey}=[^&]+`),
          `$1${encodedKey}=${encodedValue}`,
        );
      } else {
        processedParams = `${processedParams}&${encodedKey}=${encodedValue}`;
      }
    });
    return processedParams;
  }

  static createQueryParams(newParams) {
    return this.updateQueryParams('', newParams);
  }
}

export { ParamsHelper };



// WEBPACK FOOTER //
// ./src/helpers/ParamsHelper.js